import {
  createMetaTheme
} from "./chunk-QFOFFWMP.mjs";
import {
  primitiveColor
} from "./chunk-TUU3BKKT.mjs";

// src/themes/ipkLight.ts
var ipkLight = createMetaTheme({
  colors: {
    brand: {
      strong: primitiveColor.purple[80],
      default: primitiveColor.purple[70],
      subtle: primitiveColor.purple[50],
      subtler: primitiveColor.purple[20],
      subtlest: primitiveColor.purple[5],
      faint: "#846BFF26"
    }
  },
  effects: {},
  components: () => ({})
  // 기존 코드에서 커스텀 컴포넌트 설정이 없었으므로 빈 객체 반환
});

export {
  ipkLight
};
